import { memo } from 'react';
import { Circle } from '@visx/shape';

import { BrushPreviewGroupProps } from './brush-preview.model';

const ScatterPreview = memo(function ScatterGroup<T extends {}>({
    groupKey,
    group,
    xAccessor,
    yScale,
    data,
    xScale,
}: BrushPreviewGroupProps<T>) {
    return (
        <>
            {group.series.map(series => {
                const uniqId = `${groupKey}-${series.column}-scatter`;
                return (
                    <>
                        {data.map(d => {
                            const x = xScale(xAccessor(d));
                            const y = yScale(d[series.column as keyof T]);
                            return (
                                <Circle
                                    id={uniqId}
                                    key={uniqId}
                                    cx={x}
                                    cy={y}
                                    fill={series.color}
                                    r={1.5}
                                    strokeWidth={0.75}
                                    opacity={0.65}
                                />
                            );
                        })}
                    </>
                );
            })}
        </>
    );
});

export { ScatterPreview };
